/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */

/**
 * Typed goal template
 */
export type GoalType = (typeof GoalType)[keyof typeof GoalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoalType = {
  emergency_fund: 'emergency_fund',
  isa_allowance: 'isa_allowance',
  tax_reserve: 'tax_reserve',
  mortgage_payoff: 'mortgage_payoff',
  savings: 'savings',
  succession: 'succession',
  fund_family_trust: 'fund_family_trust',
  annual_gift_allowance: 'annual_gift_allowance',
  generational_transfer: 'generational_transfer',
} as const;
